import combineReducer from './combineReducer';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
	reducer: combineReducer,
	devTools: true
});

export default store;
